/** The Radix positioning props every portalled content used to accept. The
 *  names stay Radix's; `positionerProps` below translates them for Base UI.
 *  Defaults are left alone, so nothing moves unless a caller asks it to. */
export interface RadixPositioningProps {
  collisionBoundary?: Element | Element[] | "clipping-ancestors";
  collisionPadding?:
    number | Partial<Record<"top" | "right" | "bottom" | "left", number>>;
  /** Radix's `"always"` is Base UI's `sticky`; `"partial"` is its default. */
  sticky?: "partial" | "always";
  arrowPadding?: number;
  /** `false` turns off flipping and shifting on both axes. */
  avoidCollisions?: boolean;
  /** Base UI's own name, kept because Radix's `updatePositionStrategy` has no
   *  equivalent: Base UI always tracks the anchor. */
  positionMethod?: "absolute" | "fixed";
}

const NO_COLLISION_AVOIDANCE = {
  side: "none",
  align: "none",
  fallbackAxisSide: "none",
} as const;

export function positionerProps({
  collisionBoundary,
  collisionPadding,
  sticky,
  arrowPadding,
  avoidCollisions,
  positionMethod,
}: RadixPositioningProps) {
  return {
    collisionBoundary,
    collisionPadding,
    sticky: sticky === "always",
    arrowPadding,
    collisionAvoidance:
      avoidCollisions === false ? NO_COLLISION_AVOIDANCE : undefined,
    positionMethod,
  };
}
